"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.miscStencilDefinition = void 0;
const shared_1 = require("@rb3ea-backend/shared");
const models_1 = require("../models");
const properties_1 = require("../properties");
const redbullComContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'teaser',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'url',
                    'uri-title',
                    'featured-video',
                    'geolocation',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Subpages',
                items: ['subpages-container'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'editorial-publish-date',
                    'standalone',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-persons',
            'tag-teams',
        ],
    },
];
const wrcErcContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'teaser',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'url',
                    'uri-title',
                    'featured-video',
                    'geolocation',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Partners',
                items: ['partner-profiles'],
            },
            {
                name: 'Subpages',
                items: ['subpages-container'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'editorial-publish-date',
                    'standalone',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-rally-drivers',
            'tag-rally-teams',
        ],
    },
];
const redBullBoraHansgroheContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'teaser',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'url',
                    'uri-title',
                    'featured-video',
                    'geolocation',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Subpages',
                items: ['subpages-container'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'editorial-publish-date',
                    'standalone',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-persons',
            'tag-teams',
        ],
    },
];
const wrcErcProperties = {
    [properties_1.serviceEmbedPropertyDefinition.name]: {
        ...properties_1.serviceEmbedPropertyDefinition,
        constraints: [
            {
                name: 'providers',
                argument: models_1.wrcErcServiceEmbedProviders,
            },
        ],
    },
};
exports.miscStencilDefinition = {
    view: {
        label: 'Misc',
        group: 'Misc.',
        titleItems: ['title'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'teaser',
                    'story-content',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'url',
                            'uri-title',
                            'featured-video',
                            'geolocation',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'editorial-publish-date',
                            'standalone',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                ],
            },
        ],
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.ctaContainerPropertyDefinition.name]: properties_1.ctaContainerPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.editorialPublishDatePropertyDefinition.name]: properties_1.editorialPublishDatePropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.partnerProfilesPropertyDefinition.name]: properties_1.partnerProfilesPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.storyContentPropertyDefinition.name]: {
            ...properties_1.storyContentPropertyDefinition,
            constraints: [
                {
                    name: 'properties',
                    argument: [
                        'text',
                        'headline',
                        'quote',
                        'list',
                        'numbered-list',
                        'table',
                        'service-embed',
                        'image',
                        'image-gallery',
                        'video',
                        'audio',
                        'tip',
                        'fact',
                        'couple',
                        'interview',
                        'accordion',
                        'embedded-content',
                        'results-and-standings',
                        'legal-disclaimer',
                        'info-block-group',
                    ],
                },
            ],
        },
        [properties_1.subpagesContainerPropertyDefinition.name]: properties_1.subpagesContainerPropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: {
            ...properties_1.teaserPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'maxLength',
                    argument: 200,
                },
            ],
        },
        [properties_1.tagRallyDriversPropertyDefinition.name]: properties_1.tagRallyDriversPropertyDefinition,
        [properties_1.tagRallyTeamsPropertyDefinition.name]: properties_1.tagRallyTeamsPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: {
            ...properties_1.titlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 75,
                },
            ],
        },
        [properties_1.uriTitlePropertyDefinition.name]: {
            ...properties_1.uriTitlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'maxLength',
                    argument: 250,
                },
                {
                    name: 'pattern',
                    argument: '^[^#%?&/,]*$',
                },
            ],
        },
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
    },
    localizations: [],
    roles: ['xc-editor'],
    spaces: shared_1.supportedSpaces,
    name: 'misc',
    overwrites: [
        {
            condition: 'space',
            argument: 'erc',
            contentAreas: wrcErcContentAreas,
            properties: wrcErcProperties,
        },
        {
            condition: 'space',
            argument: 'wrc',
            contentAreas: wrcErcContentAreas,
            properties: wrcErcProperties,
        },
        {
            condition: 'space',
            argument: 'pro-cycling',
            contentAreas: redBullBoraHansgroheContentAreas,
        },
        {
            condition: 'space',
            argument: 'redbull_com',
            contentAreas: redbullComContentAreas,
        },
    ],
};
const isMiscStencil = (stencil) => {
    return stencil.name === exports.miscStencilDefinition.name;
};
//# sourceMappingURL=data:application/json;base64,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